const LANGUAGES = [
  'de',
  'bg',
  'cs',
  'en',
  'fr',
  'hu',
  'it',
  'ro',
  'sv',
  'tr',
  'pl',
  'nl',
];

export default LANGUAGES;
